import { Fragment, useContext, useEffect, useState } from "react";
import "../pagesGlabal.css";
import CardPackage from "../../components/CardPackage/CardPackage";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Nav } from "react-bootstrap";
import { DataContext } from "../../../pages/ConfiguraHyundai";
import AnimatedNumber from "react-animated-number";
import Image from "react-bootstrap/Image";

const Accesorios = (props) => {
    const {
        accesoriosIndividuales,
        kits,
        modeloSeleccionado,
    } = useContext(DataContext);
    const [tabSelected, setTabSelected] = useState("kit");
    const [pvpAccesorios, setPvpAccesorios] = useState(0)
    const [pvpFinal, setPvpFinal] = useState(0);
    const [imagen, setImagen] = useState(null);
    useEffect(() => {
        let imgColor = require(`../../../../images/colores/${modeloSeleccionado.MOD_CODIGO}/${modeloSeleccionado?.colorSeleccionado?.VAC_COLOR}.webp`);
        setImagen(imgColor);
        setPvpFinal(modeloSeleccionado?.versionSeleccionada?.VEA_PRECIO_PVP + pvpAccesorios);
        const obtenerPrecioAccesorios = () => {
            var sumaKits = 0;
            var sumaAccesorios = 0;
            var sumaTotal = 0;
            kits.forEach(kit =>
                sumaKits = sumaKits + kit.CK_PVP
            )
            accesoriosIndividuales.forEach((accesorio) => {
                sumaAccesorios = sumaAccesorios + accesorio.CA_PVP;
            })
            sumaTotal = sumaKits + sumaAccesorios;
            setPvpAccesorios(sumaTotal);
            setPvpFinal(sumaTotal + modeloSeleccionado?.versionSeleccionada?.VEA_PRECIO_PVP)
        }
        obtenerPrecioAccesorios();
    }, [props, pvpAccesorios, accesoriosIndividuales, kits, modeloSeleccionado])

    const handleSelect = (eventKey) => {
        setTabSelected(eventKey);
    };

    const calcularPrecioItem = (operacion, item) => {
        //si operacion es true se suma, caso contrario se resta
        if (operacion === "SUMAR") {
            let suma = pvpAccesorios + item
            setPvpAccesorios(suma)
            setPvpFinal(pvpFinal + item);
        } else {
            let resta = pvpAccesorios - item
            setPvpAccesorios(resta);
            setPvpFinal(pvpFinal - item)
        }
    }

    return (
        <Fragment>
            <section>
                <div className="rellenar">
                    <Row className='ajustar-fila m-0'>
                        <Col md={4}
                            className='p-0'
                        >
                            <div
                                className="box-scroll"
                            >
                                <div className='ml-3 mr-3 pt-3'>
                                    <p className="h-head-of h18 mt-3">Elige los accesorios de tu vehículo</p>
                                </div>
                                <Nav fill variant="tabs" onSelect={handleSelect}>
                                    <Nav.Item>
                                        {tabSelected === "kit" ?
                                            <Nav.Link className="tab-seleccionado" eventKey="kit" active={true}>Kits</Nav.Link>
                                            :
                                            <Nav.Link className="tab-seleccionado" eventKey="kit" active={false}>Kits</Nav.Link>
                                        }
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link className="tab-seleccionado" eventKey="individual">Individuales</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                                <CardPackage
                                    optionSelected={tabSelected}
                                    calcularPrecioItem={calcularPrecioItem}
                                />
                            </div>
                        </Col>
                        <Col md={8}>
                            <div>
                                <Row className="centrar-global">
                                    <Col md={9} className="contenedor-360">
                                        <center>
                                            <Image className="img-ve" src={imagen} alt="Hyundai vehiculo" width={510} height={260} />
                                        </center>
                                    </Col>
                                </Row>
                            </div>
                            <div className="build-bottom">
                                <Row style={{ width: '100%' }} className="text-right justify-content-end">
                                    <Col md={10} xs={6} className='text-right'>
                                        <span>Precio Base:</span> <br />
                                        <span>Accesorios:</span> <br />
                                        <span className='h20'><b>Precio final:</b></span> <br />
                                    </Col>
                                    <Col md={2} xs={6} className='text-left'>
                                        <span>{modeloSeleccionado?.versionSeleccionada?.VEA_PRECIO_PVP.toLocaleString('en-US', {
                                            style: 'currency',
                                            currency: 'USD'
                                        })} </span> <br />
                                        <span>{pvpAccesorios?.toLocaleString("en-US", {
                                            style: 'currency',
                                            currency: 'USD'
                                        })}</span> <br />|
                                        <AnimatedNumber
                                            value={pvpFinal}
                                            className="h20 h-txt-r"
                                            formatValue={n => n.toLocaleString('en-US', {
                                                style: 'currency',
                                                currency: 'USD'
                                            })}
                                            duration={400}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>
        </Fragment>
    );
};
export default Accesorios;